import iconSismos from "../../../assets/images/fenomenos/sismos-volcanicos.png";
import iconDeformacion from "../../../assets/images/fenomenos/deformacion.png";
import iconOndas from "../../../assets/images/fenomenos/ondas-de-choque.png";
import iconRayo from "../../../assets/images/fenomenos/rayo-volcanico.png";
import iconIncandescencia from "../../../assets/images/fenomenos/incandescencia.png";
import { normalizeTipoFenomeno } from "./fenomenosAsociadosColumns";

export const FENOMENO_TIPOS_CATALOGO = [
  {
    label: "Sismos volcánicos",
    icon: iconSismos,
    normKey: "sismos volcanicos",
    aliases: ["sismos volcanicos", "sismos volcánicos", "sismo volcanico"],
  },
  {
    label: "Deformación",
    icon: iconDeformacion,
    normKey: "deformacion",
    aliases: ["deformacion", "deformación"],
  },
  {
    label: "Ondas de choque",
    icon: iconOndas,
    normKey: "onda de choque",
    aliases: ["onda de choque", "ondas de choque"],
  },
  {
    label: "Rayo volcánico",
    icon: iconRayo,
    normKey: "rayo volcanico",
    aliases: ["rayo volcanico", "rayo volcánico"],
  },
  {
    label: "Incandescencia",
    icon: iconIncandescencia,
    normKey: "incandescencia",
    aliases: ["incandescencia"],
  },
];

export function getFenomenoCatalogLabel(rawTipo) {
  const norm = normalizeTipoFenomeno(rawTipo);
  if (!norm) return null;

  const match = FENOMENO_TIPOS_CATALOGO.find((item) =>
    item.aliases.some((alias) => normalizeTipoFenomeno(alias) === norm),
  );

  return match?.label ?? null;
}

export function getFenomenoTipoNormFromLabel(catalogLabel) {
  const item = FENOMENO_TIPOS_CATALOGO.find(
    (entry) => entry.label === catalogLabel,
  );
  if (!item) return normalizeTipoFenomeno(catalogLabel);
  return normalizeTipoFenomeno(item.normKey);
}

export function fenomenoBelongsToTipo(row, catalogLabel) {
  const raw = String(
    row?.tipo_fenomeno_asociado ?? row?.tipo_fenomeno ?? row?.tipo ?? "",
  ).trim();
  return getFenomenoCatalogLabel(raw) === catalogLabel;
}

export function getFenomenoTiposConDatos(rows) {
  return FENOMENO_TIPOS_CATALOGO.filter((item) =>
    (rows || []).some((row) => fenomenoBelongsToTipo(row, item.label)),
  );
}
